<div class="loading-overlay">
    <div class="loading-spinner"></div>
</div>